import React, { useRef } from "react";
import {
  Button,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Alert,
  AlertIcon,
  AlertDescription,
} from "@chakra-ui/react";

function RadianseAlertDialog({
  title = null,
  alertBody,
  confirm,
  confirmationText = "OK",
  cancelText,
  isOpen,
  onClose,
  showAdditionalAlert,
}) {
  const cancelRef = useRef(null);

  function confirmationHandler() {
    confirm();
  }

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          {title && (
            <AlertDialogHeader
              fontSize="lg"
              color="brand.text.primary"
              fontWeight="bold"
            >
              {title}
            </AlertDialogHeader>
          )}
          <AlertDialogBody color="brand.text.primary">
            {alertBody}
            {showAdditionalAlert && (
              <Alert mt="4" status="warning">
                <AlertIcon />
                <AlertDescription>
                  This action cannot be undone.
                </AlertDescription>
              </Alert>
            )}
          </AlertDialogBody>
          <AlertDialogFooter>
            {cancelText && (
              <Button
                ml="2"
                variant="default"
                ref={cancelRef}
                onClick={onClose}
                data-testid={"alert-cancel"}
              >
                {cancelText}
              </Button>
            )}
            {confirmationText && (
              <Button
                mr="2"
                variant="solid"
                colorScheme="red"
                onClick={confirmationHandler}
                data-testid={"alert-confirm"}
                ml={3}
              >
                {confirmationText}
              </Button>
            )}
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}

export default RadianseAlertDialog;
